import { useContext } from 'react';

import BaseViewsContext from 'contexts/BaseViewsContext';
import useMetric from 'hooks/useMetric';

import { isRecordsTable } from '../buildTableDefinition';
import { useKpiListScorecard } from '../kpiList';
import { getLegacyGadgetBlockName } from '../legacyGadgetBlocks';
import { resolveSeriesMetricId } from '../seriesVariants';

// A chart element's title, in its header and as its chart's name: its label,
// else its primary metric's name (a records Table's dataset, a KPI list's KPI
// List, or what a legacy gadget is called, e.g. Reminders). The fallback is what an empty
// label shows.
const useElementTitle = (
  element: Studio.CompositeElement,
): { title: string; fallback: string } => {
  const { getDatasetLabel } = useContext(BaseViewsContext);
  const [primaryKey] = element.metricIds ?? [];
  const metric = useMetric(
    primaryKey
      ? resolveSeriesMetricId({ card: element, key: primaryKey })
      : undefined,
  );
  const { scorecard } = useKpiListScorecard(element);
  const isRecords = isRecordsTable(element);
  const dataType = isRecords ? element.table?.records?.dataType : undefined;
  const fallback = isRecords
    ? dataType
      ? getDatasetLabel(dataType)
      : 'Records'
    : scorecard
      ? scorecard.title
      : getLegacyGadgetBlockName(element) ?? (metric ? metric.name : '');
  return { title: element.label || fallback, fallback };
};

export default useElementTitle;
